import { Component, Inject } from '@angular/core';
import { WINDOW } from '@lib/browser/window-providers';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApplicationVersionRepository } from './application-version-repository';
import { newestApplicationVersion$ as newestVersion$ } from './newest-application-version';

@Component({
  selector: 'app-automatic-update',
  templateUrl: './automatic-update.component.html',
  styleUrls: ['./automatic-update.component.scss'],
})
export class AutomaticUpdateComponent {
  constructor(
    private versionRepository: ApplicationVersionRepository,
    @Inject(WINDOW) private windowRef: Window,
  ) {}

  currentVersion$ = this.versionRepository.currentVersion();

  needsUpdate$ = combineLatest(newestVersion$, this.currentVersion$).pipe(
    map(([newest, current]) => newest.version > current.version),
  );

  public updateApplication() {
    this.windowRef.location.reload();
  }
}
